// src/pages/GestionarUsuariosAutenticados.js
import React, { useState, useEffect, useMemo } from 'react';
import { db, auth, functions } from '../firebase';
import { collection, getDocs, query, where, doc, updateDoc, getDoc, addDoc, deleteDoc } from 'firebase/firestore';

import { sendPasswordResetEmail } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions'; import { useNavigate } from 'react-router-dom'; import PlatformBackButton from '../components/PlatformBackButton';
import { FaUsers, FaSearch, FaKey, FaPen, FaPlus, FaTimes, FaDollarSign, FaChevronLeft, FaChevronRight, FaChevronDown } from 'react-icons/fa';

import { FiAlertTriangle, FiCheckCircle, FiEye, FiEyeOff, FiLock, FiUnlock, FiEdit2 } from 'react-icons/fi';
import ConfirmModal from '../components/ConfirmModal';
import { esCasaCaseta } from '../utils/morosoUtils';
import './GestionarUsuariosAutenticados.css';

const PASSWORD_ENDPOINT = 'https://us-central1-gestionpagosfracc.cloudfunctions.net/setUserPasswordHttp';
const SUSPEND_ENDPOINT = 'https://suspenduserhttp-gb5hv5xxaq-uc.a.run.app';
const MONTH_NAMES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const GestionarUsuariosAutenticados = () => {
    const navigate = useNavigate();
    const [fraccionamientos, setFraccionamientos] = useState([]);
    const [selectedFraccUsuarios, setSelectedFraccUsuarios] = useState('');
    const [usuariosFracc, setUsuariosFracc] = useState([]);
    const [usuariosLoading, setUsuariosLoading] = useState(false);
    const [usuariosError, setUsuariosError] = useState('');
    const [loadingFraccionamientos, setLoadingFraccionamientos] = useState(true);
    const [editingUser, setEditingUser] = useState(null);
    const [editForm, setEditForm] = useState({ nombre: '', correo: '', usuario: '', telefono: '', contrasena: '', rol: '' });
    const [saving, setSaving] = useState(false);
    const [sendingReset, setSendingReset] = useState('');
    const [resetFeedback, setResetFeedback] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [showPlatformAdminConfirm, setShowPlatformAdminConfirm] = useState(false);
    const [pendingRole, setPendingRole] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [activeTab, setActiveTab] = useState('perfil'); // 'perfil' | 'campos'
    const [customFields, setCustomFields] = useState([]); // [{name, value}]
    const [eliminandoCasas, setEliminandoCasas] = useState(false);
    
    // Estados para Regularización
    const [showRegModal, setShowRegModal] = useState(false);
    const [regUser, setRegUser] = useState(null);
    const [regCasaData, setRegCasaData] = useState(null);
    const [regMesesData, setRegMesesData] = useState([]);
    const [regMultasList, setRegMultasList] = useState([]);
    const [regActiveTab, setRegActiveTab] = useState('datos'); 
    const [regLoading, setRegLoading] = useState(false);
    const [regSaving, setRegSaving] = useState(false);
    const [regExecuting, setRegExecuting] = useState(false);
    
    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 60;
    
    // Paginación Regularización (12 meses = 1 año)
    const [regCurrentPage, setRegCurrentPage] = useState(1);
    const REG_ITEMS_PER_PAGE = 12;

    // Estados para Histórico Acumulado
    const [regSubdivisionConfig, setRegSubdivisionConfig] = useState(null);
    const [regHistoricoList, setRegHistoricoList] = useState([]);
    const [regHistoricoForm, setRegHistoricoForm] = useState({ de: '', hasta: '', cuota: '' });
    const [expandedRegYears, setExpandedRegYears] = useState([]); // IDs de años expandidos


    // Estados para modales de confirmación
    const [confirmModal, setConfirmModal] = useState({
        isOpen: false,
        title: '',
        message: '',
        type: 'info',
        onConfirm: () => { },
        confirmText: 'Confirmar',
        showCancel: true,
    });

    // Cache de usuarios por fraccionamiento para búsqueda avanzada
    const [usuariosPorFracc, setUsuariosPorFracc] = useState({});

    // Cargar fraccionamientos al montar
    useEffect(() => {
        const loadFraccionamientos = async () => {
            try {
                setLoadingFraccionamientos(true);
                const snapshot = await getDocs(collection(db, 'fraccionamientos'));
                const fraccList = [];
                snapshot.forEach((docSnap) => {
                    fraccList.push({
                        id: docSnap.id,
                        nombre: docSnap.data()?.nombre || docSnap.data()?.nombreFracc || 'Sin nombre'
                    });
                });
                setFraccionamientos(fraccList);

                // Cargar usuarios de cada fraccionamiento para búsqueda avanzada
                const usuariosCache = {};
                for (const fracc of fraccList) {
                    try {
                        const qById = query(collection(db, 'usuarios'), where('fraccionamientoId', '==', fracc.id));
                        const snap = await getDocs(qById);
                        usuariosCache[fracc.id] = snap.docs.map((d) => ({
                            id: d.id,
                            nombre: d.data().nombre || d.data().displayName || '',
                            correo: d.data().correo || d.data().email || '',
                        }));
                    } catch (err) {
                        console.error(`Error cargando usuarios de ${fracc.nombre}:`, err);
                        usuariosCache[fracc.id] = [];
                    }
                }
                setUsuariosPorFracc(usuariosCache);
            } catch (error) {
                console.error('Error cargando fraccionamientos:', error);
            } finally {
                setLoadingFraccionamientos(false);
            }
        };

        loadFraccionamientos();
    }, []);

    // Lógica para agrupar meses históricos por año
    const aggregatedRegMeses = useMemo(() => {
        if (!regMesesData || regMesesData.length === 0) return [];
        
        const result = [];
        const historyByYear = {};

        // Separamos meses actuales de históricos
        regMesesData.forEach(mes => {
            const year = mes.año || mes.anio || (mes.id ? parseInt(mes.id.replace('his-', '').split('-')[0], 10) : null);
            const monthNum = mes.mes || (mes.id ? parseInt(mes.id.replace('his-', '').split('-')[1], 10) : 1);
            const scoreMes = (year && monthNum) ? (year * 12 + monthNum) : null;
            // Buscar cuota en configuración histórica para mostrar la correcta según el periodo exacto (mes y año)
            const configHist = regHistoricoList.find(h => {
                if (!scoreMes) return false;
                const sIni = (h.anioInicio || h.añoInicio || 0) * 12 + (h.mesInicio || 1);
                const sFin = (h.anioFin || h.añoFin || 0) * 12 + (h.mesFin || 12);
                return scoreMes >= sIni && scoreMes <= sFin;
            });
            const cuotaCorrecta = configHist ? configHist.cuota : mes.cuotaMensual;

            if (mes.id.startsWith('his-')) {
                if (!historyByYear[year]) {
                    historyByYear[year] = {
                        id: `year-${year}`,
                        año: year,
                        isGroup: true,
                        meses: [],
                        montoPagado: 0,
                        montoPendiente: 0,
                        cuotaMensual: cuotaCorrecta,
                        estado: 'pagado_totalmente'
                    };
                }
                const mesIdx = parseInt(mes.mes) - 1;
                const mesConNombre = {
                    ...mes,
                    cuotaMensual: cuotaCorrecta, // Forzar visualmente la cuota configurada
                    mesNombre: MONTH_NAMES[mesIdx] || `Mes ${mes.mes}`
                };
                historyByYear[year].meses.push(mesConNombre);
                historyByYear[year].montoPagado += (mes.montoPagado || 0);
                historyByYear[year].montoPendiente += (mes.montoPendiente || 0);
                // Si algún mes está pendiente o parcial, el año completo se marca como pendiente
                if (mes.estado === 'pendiente' || mes.estado === 'pagado_parcialmente') {
                    historyByYear[year].estado = 'pendiente';
                }
            } else {
                result.push({ ...mes, cuotaMensual: cuotaCorrecta });
            }
        });

        // Convertir grupos a filas y ordenar
        const historyRows = Object.values(historyByYear).sort((a,b) => b.año - a.año).map(group => {
            const mesesSorted = [...group.meses].sort((a,b) => a.mes - b.mes);
            const minMes = mesesSorted[0].mes;
            const maxMes = mesesSorted[mesesSorted.length - 1].mes;
            const count = group.meses.length;
            
            return {
                ...group,
                displayId: `${group.año} [${String(minMes).padStart(2,'0')}/${String(maxMes).padStart(2,'0')}]`,
                count
            };
        });

        // Resultado: Meses del año actual primero (usualmente más recientes en regMesesData), luego histórico agrupado
        return [...result, ...historyRows];
    }, [regMesesData]);

    const totalRegPages = Math.ceil(aggregatedRegMeses.length / REG_ITEMS_PER_PAGE);
    const paginatedRegMeses = aggregatedRegMeses.slice(
        (regCurrentPage - 1) * REG_ITEMS_PER_PAGE, 
        regCurrentPage * REG_ITEMS_PER_PAGE
    );

    // Detección de deuda histórica (> lo correspondiente al año actual 2026)
    const currentYear_Now = new Date().getFullYear();
    const currentMonth_Now = new Date().getMonth() + 1;
    const currentDay_Now = new Date().getDate();
    const corteDiaRef = parseInt(regSubdivisionConfig?.corteDia || 1);
    const currentFeeRef = parseFloat(regSubdivisionConfig?.montoMensual || 0);

    // Meses que deberían estar pagados en el año actual hasta hoy (según día de corte)
    let monthsToPayCurrentYear = currentMonth_Now;
    if (currentDay_Now < corteDiaRef) {
        monthsToPayCurrentYear = Math.max(0, currentMonth_Now - 1);
    }
    const currentYearDebtLimit = monthsToPayCurrentYear * currentFeeRef;
    
    // Es histórica si el adeudo total supera el límite del año actual
    const isHistoricDebt = currentFeeRef > 0 && (regCasaData?.adeudo || 0) > currentYearDebtLimit;

    // Efecto para ocultar el botón de novedades cuando hay un modal abierto
    useEffect(() => {
        const isModalOpen = !!editingUser || showRegModal || showPlatformAdminConfirm || !!resetFeedback;
        if (isModalOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        return () => document.body.classList.remove('modal-open');
    }, [editingUser, showRegModal, showPlatformAdminConfirm, resetFeedback]);

    const obtenerNumeroCasaUsuario = (u) => {
        if (u?.casasAsociadas && u.casasAsociadas.length > 0) {
            return String(u.casasAsociadas[0]?.numero || u.casasAsociadas[0]?.id || '').trim();
        }
        return String(u?.casaInfo?.numero || u?.casaInfo?.id || u?.numeroCasa || u?.numero || u?.lote || '').trim();
    };

    const compararUsuariosPorCasa = (a, b) => {
        const numA = obtenerNumeroCasaUsuario(a);
        const numB = obtenerNumeroCasaUsuario(b);
        if (!numA && !numB) {
            const nomA = (a.nombre || a.displayName || a.nombreUsuario || '').trim();
            const nomB = (b.nombre || b.displayName || b.nombreUsuario || '').trim();
            return nomA.localeCompare(nomB, undefined, { numeric: true, sensitivity: 'base' });
        }
        if (!numA) return 1;
        if (!numB) return -1;
        return numA.localeCompare(numB, undefined, { numeric: true, sensitivity: 'base' });
    };

    const handleSelectFraccUsuarios = async (event) => {
        const fraccId = event.target.value;
        setSelectedFraccUsuarios(fraccId);
        setUsuariosError('');
        setUsuariosFracc([]);

        if (!fraccId) {
            return;
        }

        setCurrentPage(1); // Reset al cambiar de fraccionamiento

        setUsuariosLoading(true);
        try {
            const usuariosRef = collection(db, 'usuarios');
            const qById = query(usuariosRef, where('fraccionamientoId', '==', fraccId));
            const qByLegacy = query(usuariosRef, where('fraccionamientoTd', '==', fraccId));
            const qByAssigned = query(usuariosRef, where('fraccionamientosAsignados', 'array-contains', fraccId));
            const fraccUsersRef = collection(db, 'fraccionamientos', fraccId, 'usuarios');
            const fraccCasasRef = collection(db, 'fraccionamientos', fraccId, 'casas');

            console.log(`[GestionarUsuarios] Buscando usuarios para fraccionamiento: ${fraccId}`);

            const [snapId, snapLegacy, snapAssigned, snapFraccUsers, snapCasas] = await Promise.all([
                getDocs(qById),
                getDocs(qByLegacy),
                getDocs(qByAssigned),
                getDocs(fraccUsersRef),
                getDocs(fraccCasasRef),
            ]);

            // Crear mapa de casas por email para enlazar info (soporta múltiples casas por email)
            const casaMap = {};
            snapCasas.docs.forEach((c) => {
                const d = c.data();
                const emails = [d.email, d.correo].filter((e) => e && typeof e === 'string').map((e) => e.trim().toLowerCase());
                emails.forEach((e) => {
                    if (!casaMap[e]) {
                        casaMap[e] = [];
                    }
                    if (!casaMap[e].some((existing) => existing.id === c.id)) {
                        casaMap[e].push({ id: c.id, ...d });
                    }
                });
            });

            const usuarios = [];
            const seenIds = new Set();
            const seenEmails = new Set();

            const mergeDocs = (snap, sourceName) => {
                snap.docs.forEach((docSnap) => {
                    const data = docSnap.data() || {};
                    const docId = docSnap.id;
                    const correo = (data.correo || data.email || '').trim().toLowerCase();

                    // Evitar duplicados por ID (UID)
                    if (seenIds.has(docId)) return;

                    // Evitar duplicados por email si ya vimos este correo en otro documento
                    if (correo && seenEmails.has(correo)) return;

                    // Buscar info de casa si existe (prioridad por UID o por Email)
                    let casasAsociadas = [];
                    if (correo && casaMap[correo]) {
                        casasAsociadas = [...casaMap[correo]];
                    }

                    // Búsqueda reversa o por ID
                    snapCasas.docs.forEach((c) => {
                        const d = c.data();
                        if (d.userId === docId || d.uid === docId) {
                            if (!casasAsociadas.some((existing) => existing.id === c.id)) {
                                casasAsociadas.push({ id: c.id, ...d });
                            }
                        }
                    });

                    const casaInfo = casasAsociadas.length > 0 ? casasAsociadas[0] : null;

                    seenIds.add(docId);
                    if (correo) seenEmails.add(correo);
                    usuarios.push({ id: docId, ...data, casaInfo, casasAsociadas });
                });
            };

            // Primero cargar usuarios autenticados
            mergeDocs(snapId, 'fraccionamientoId');
            mergeDocs(snapLegacy, 'fraccionamientoTd');
            mergeDocs(snapAssigned, 'fraccionamientosAsignados');
            mergeDocs(snapFraccUsers, 'subcolección fracc/usuarios');

            // Ahora buscar casas con emails que NO estén autenticados
            let casasAgregadas = 0;
            snapCasas.docs.forEach((casaDoc) => {
                const casaData = casaDoc.data() || {};
                const emailCasa = (casaData.email || casaData.correo || '').trim().toLowerCase();

                if (!emailCasa) return;
                if (seenEmails.has(emailCasa)) return;

                const nombre = casaData.nombre_residente || casaData.propietario || casaData.residente || `Casa ${casaData.numero || casaDoc.id}`;
                const casasAsociadas = casaMap[emailCasa] || [{ id: casaDoc.id, ...casaData }];
                const casaInfo = casasAsociadas[0] || { id: casaDoc.id, ...casaData };

                const usuarioNoAuth = {
                    id: `casa_${casaDoc.id}`,
                    nombre: nombre,
                    correo: emailCasa,
                    email: emailCasa,
                    nombreUsuario: emailCasa.split('@')[0],
                    usuario: emailCasa.split('@')[0],
                    rol: 'user',
                    casaInfo,
                    casasAsociadas,
                    esNoAutenticado: true,
                };

                seenEmails.add(emailCasa);
                usuarios.push(usuarioNoAuth);
                casasAgregadas++;
            });

            console.log(`[GestionarUsuarios] Total usuarios: ${usuarios.length} (${casasAgregadas} de casas)`);
            usuarios.sort(compararUsuariosPorCasa);
            setUsuariosFracc(usuarios);
        } catch (err) {
            console.error('No se pudieron cargar los usuarios del fraccionamiento', err);
            setUsuariosError('No pudimos cargar los usuarios de este fraccionamiento. Intenta nuevamente.');
        } finally {
            setUsuariosLoading(false);
        }
    };

    const resolveAuthDate = (usuario) => {
        const ts = usuario.fechaCreacion || usuario.createdAt || usuario.creadoEn || usuario.fechaRegistro;
        if (ts?.toDate) return ts.toDate();
        if (typeof ts === 'number') return new Date(ts);
        if (typeof ts === 'string') {
            const d = new Date(ts);
            return Number.isNaN(d.getTime()) ? null : d;
        }
        return null;
    };

    const formatDateTime = (date) => {
        if (!date) return '—';
        return date.toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
    };

    const toggleRegYear = (yearId) => {
        setExpandedRegYears(prev => 
            prev.includes(yearId) ? prev.filter(id => id !== yearId) : [...prev, yearId]
        );
    };

    const openEditModal = (usuario) => {
        setEditingUser(usuario);
        const casaInfo = usuario.casaInfo || {};

        // Prioridad: Datos de la casa (para Usuario y Correo) > Datos de Auth
        // "Usuario" input = nombre_residente de la casa
        // "Correo" input = email de la casa
        const usuarioVal = casaInfo.nombre_residente || usuario.nombreUsuario || usuario.usuario || usuario.email || '';
        const correoVal = casaInfo.email || casaInfo.correo || usuario.correo || usuario.email || '';

        setEditForm({
            nombre: usuario.nombre || usuario.displayName || usuario.nombreUsuario || '',
            correo: correoVal,
            usuario: usuarioVal,
            rol: usuario.rol || '',
            nuevaContrasena: '',
            confirmContrasena: '',
        });
        setPasswordError('');
        setActiveTab('perfil');

        // Intentar cargar campos desde el usuario o desde la info de la casa
        const cf = usuario.customFields || usuario.camposPersonalizados || usuario.casaInfo?.customFields || usuario.casaInfo?.camposPersonalizados || [];

        if (Array.isArray(cf)) {
            setCustomFields(cf.map((f) => ({ name: f.name || f.nombre || '', value: f.value || f.valor || '' })));
        } else if (cf && typeof cf === 'object') {
            setCustomFields(Object.entries(cf).map(([name, value]) => ({ name, value })));
        } else {
            setCustomFields([]);
        }
    };

    const forceCloseEditModal = () => {
        setEditingUser(null);
        setSaving(false);
    };

    const handleCloseEditModal = () => {
        // Detectar si hay cambios sin guardar
        const isDirty = 
            editForm.nombre !== (editingUser.nombre || editingUser.displayName || '') ||
            editForm.correo !== (editingUser.correo || editingUser.email || '') ||
            editForm.usuario !== (editingUser.nombreUsuario || editingUser.usuario || '') ||
            editForm.rol !== (editingUser.rol || '') ||
            editForm.nuevaContrasena !== '';

        if (isDirty) {
            setConfirmModal({
                isOpen: true,
                title: '¿Descartar cambios?',
                message: 'Tienes cambios sin guardar. ¿Estás seguro de que deseas salir?',
                type: 'warning',
                confirmText: 'Sí, salir',
                cancelText: 'Continuar editando',
                showCancel: true,
                confirmColor: '#2196f3', // Azul
                cancelColor: '#800020',  // Guinda
                onConfirm: () => {
                    setConfirmModal(prev => ({ ...prev, isOpen: false }));
                    forceCloseEditModal();
                },
                onCancel: () => setConfirmModal(prev => ({ ...prev, isOpen: false })),
            });
        } else {
            forceCloseEditModal();
        }
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        if (name === 'rol' && value === 'platformadmin') {
            setPendingRole(value);
            setShowPlatformAdminConfirm(true);
        } else {
            setEditForm((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleConfirmPlatformAdmin = () => {
        setEditForm((prev) => ({ ...prev, rol: pendingRole }));
        setShowPlatformAdminConfirm(false);
        setPendingRole('');
    };

    const handleCancelPlatformAdmin = () => {
        setShowPlatformAdminConfirm(false);
        setPendingRole('');
    };

    const handleSave = async () => {
        if (!editingUser) return;
        setSaving(true);
        setPasswordError('');

        try {
            const passTrimmed = (editForm.nuevaContrasena || '').trim();
            const confirmTrimmed = (editForm.confirmContrasena || '').trim();

            if (passTrimmed) {
                if (passTrimmed.length < 6) {
                    setPasswordError('La contraseña debe tener al menos 6 caracteres.');
                    setSaving(false);
                    return;
                }
                if (passTrimmed !== confirmTrimmed) {
                    setPasswordError('Las contraseñas no coinciden.');
                    setSaving(false);
                    return;
                }
            }

            const targetEmail = (editForm.correo || editingUser.correo || editingUser.email || '').trim().toLowerCase();
            const customFieldsObj = Object.fromEntries(
                (customFields || []).filter((f) => (f.name || '').trim().length > 0)
                    .map((f) => [f.name.trim(), (f.value ?? '').toString()])
            );

            let assignedUid = editingUser.esNoAutenticado ? null : editingUser.id;

            // Si existe un correo destino, buscar si ya existe un UID oficial para este correo en la plataforma
            if (targetEmail) {
                try {
                    const usuariosRef = collection(db, 'usuarios');
                    const qEmail = query(usuariosRef, where('email', '==', targetEmail));
                    const snapEmail = await getDocs(qEmail);
                    if (!snapEmail.empty) {
                        assignedUid = snapEmail.docs[0].id;
                        console.log('[GestionarUsuarios] Usuario oficial reutilizado para multi-fraccionamiento con UID:', assignedUid);
                    }
                } catch (e) {
                    console.warn('[GestionarUsuarios] Error buscando email en usuarios:', e);
                }
            }

            // 1. Asignar contraseña a través de Cloud Function (funciona para usuarios existentes o no autenticados)
            if (passTrimmed) {
                try {
                    console.log(`[GestionarUsuarios] Asignando contraseña manualmente para ${targetEmail}...`);
                    const setUserPassFn = httpsCallable(functions, 'setUserPassword');
                    const passResult = await setUserPassFn({
                        uid: assignedUid || undefined,
                        email: targetEmail,
                        newPassword: passTrimmed,
                        password: passTrimmed,
                        nuevaContrasena: passTrimmed,
                        rol: editForm.rol === 'residente' ? 'user' : (editForm.rol || 'user')
                    });

                    if (passResult.data && passResult.data.uid) {
                        assignedUid = passResult.data.uid;
                        console.log('[GestionarUsuarios] Contraseña asignada con éxito. UID en Auth:', assignedUid);
                    }
                } catch (passErr) {
                    console.error('[GestionarUsuarios] Error asignando contraseña vía callable:', passErr);
                    // Fallback a endpoint HTTP con CORS explícito
                    try {
                        console.log('[GestionarUsuarios] Reintentando asignación vía endpoint HTTP...');
                        const httpRes = await fetch(PASSWORD_ENDPOINT, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                uid: assignedUid || undefined,
                                email: targetEmail,
                                newPassword: passTrimmed,
                                password: passTrimmed,
                                rol: editForm.rol === 'residente' ? 'user' : (editForm.rol || 'user')
                            })
                        });
                        const httpData = await httpRes.json();
                        if (httpData && httpData.success && httpData.uid) {
                            assignedUid = httpData.uid;
                            console.log('[GestionarUsuarios] Contraseña asignada vía endpoint HTTP. UID:', assignedUid);
                        } else {
                            throw new Error(httpData?.message || 'Error en endpoint HTTP');
                        }
                    } catch (httpFallbackErr) {
                        console.error('[GestionarUsuarios] Fallback HTTP también falló:', httpFallbackErr);
                        alert('No se pudo establecer la contraseña en Firebase Auth: ' + (passErr.message || httpFallbackErr.message || 'Error desconocido'));
                        setSaving(false);
                        return;
                    }
                }
            }

            // Asegurar que el fraccionamiento se agregue a la lista de fraccionamientosAsignados del usuario
            if (assignedUid && selectedFraccUsuarios) {
                try {
                    const userRef = doc(db, 'usuarios', assignedUid);
                    const { arrayUnion } = await import('firebase/firestore');
                    await updateDoc(userRef, {
                        fraccionamientosAsignados: arrayUnion(selectedFraccUsuarios)
                    });
                } catch (unionErr) {
                    console.warn('[GestionarUsuarios] Error agregando fraccionamientosAsignados:', unionErr);
                }
            }

            // --- SINCRONIZACIÓN MAESTRA DE IDENTIDAD (CORREO / NOMBRE) ---
            if (assignedUid && !editingUser.esNoAutenticado) {
                try {
                    const originalEmail = (editingUser.correo || editingUser.email || '').trim().toLowerCase();
                    const emailChanged = targetEmail && originalEmail && targetEmail !== originalEmail;

                    const updateAuthEmailFn = httpsCallable(functions, 'updateUserAuthEmail');
                    await updateAuthEmailFn({ 
                        uid: assignedUid, 
                        newEmail: emailChanged ? targetEmail : undefined,
                        newName: editForm.nombre,
                        fraccionamientoId: selectedFraccUsuarios,
                        casaId: editingUser.casaInfo?.id
                    });
                } catch (authErr) {
                    console.warn('[GestionarUsuarios] Advertencia en sincronización de email:', authErr);
                }
            }

            // 2. Crear o actualizar documento oficial en la colección /usuarios
            if (assignedUid) {
                const userRef = doc(db, 'usuarios', assignedUid);
                const customFieldsConDisplayName = {
                    ...customFieldsObj,
                    displayName: editForm.nombre,
                    email: targetEmail,
                };
                const userUpdate = {
                    nombre: editForm.nombre,
                    nombreCompleto: editForm.nombre,
                    displayName: editForm.nombre,
                    correo: targetEmail,
                    email: targetEmail,
                    nombreUsuario: editForm.usuario || editForm.nombre || targetEmail.split('@')[0],
                    rol: editForm.rol === 'residente' ? 'user' : (editForm.rol || 'user'),
                    fraccionamientoId: selectedFraccUsuarios,
                    customFields: customFieldsConDisplayName,
                    updatedAt: new Date().toISOString()
                };
                const { setDoc } = await import('firebase/firestore');
                await setDoc(userRef, userUpdate, { merge: true });
            }

            // 3. Actualizar campos en el documento de Casa y vincular userId si aplica
            const isRolCasetaAsignado = ['caseta', 'guardia', 'vigilancia', 'seguridad', 'control_acceso', 'portero'].includes(String(editForm.rol).toLowerCase()) || esCasaCaseta({ ...editingUser, rol: editForm.rol, email: targetEmail, correo: targetEmail });

            if (selectedFraccUsuarios && editingUser.casasAsociadas && editingUser.casasAsociadas.length > 0) {
                for (const casa of editingUser.casasAsociadas) {
                    const casaRef = doc(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', casa.id);
                    const casaUpdate = {
                        nombre_residente: editForm.nombre,
                        nombreCompleto: editForm.nombre,
                        email: targetEmail,
                        correo: targetEmail,
                        customFields: customFieldsObj,
                        updatedAt: new Date().toISOString(),
                    };
                    if (isRolCasetaAsignado) {
                        casaUpdate.esRolCaseta = true;
                        casaUpdate.rol = 'caseta';
                        casaUpdate.rolAsignado = 'caseta';
                        casaUpdate.perfil = 'caseta';
                        casaUpdate.adeudo = 0;
                        casaUpdate.adeudoCapital = 0;
                        casaUpdate.adeudoIntereses = 0;
                        casaUpdate.adeudoInteres = 0;
                        casaUpdate.adeudoAgua = 0;
                        casaUpdate.cuotasExtras = 0;
                        casaUpdate.saldoFavor = 0;
                        casaUpdate.moroso = false;
                        casaUpdate.mesesAdeudo = 0;
                    }
                    if (assignedUid) {
                        casaUpdate.userId = assignedUid;
                    }
                    await updateDoc(casaRef, casaUpdate);
                }
            } else if (selectedFraccUsuarios && editingUser.casaInfo?.id) {
                const casaRef = doc(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', editingUser.casaInfo.id);
                const casaUpdate = {
                    nombre_residente: editForm.nombre,
                    nombreCompleto: editForm.nombre,
                    email: targetEmail,
                    correo: targetEmail,
                    customFields: customFieldsObj,
                    updatedAt: new Date().toISOString(),
                };
                if (isRolCasetaAsignado) {
                    casaUpdate.esRolCaseta = true;
                    casaUpdate.rol = 'caseta';
                    casaUpdate.rolAsignado = 'caseta';
                    casaUpdate.perfil = 'caseta';
                    casaUpdate.adeudo = 0;
                    casaUpdate.adeudoCapital = 0;
                    casaUpdate.adeudoIntereses = 0;
                    casaUpdate.adeudoInteres = 0;
                    casaUpdate.adeudoAgua = 0;
                    casaUpdate.cuotasExtras = 0;
                    casaUpdate.saldoFavor = 0;
                    casaUpdate.moroso = false;
                    casaUpdate.mesesAdeudo = 0;
                }
                if (assignedUid) {
                    casaUpdate.userId = assignedUid;
                }
                await updateDoc(casaRef, casaUpdate);
            }

            // 4. Actualizar estado local
            setUsuariosFracc((prev) => prev.map((u) => {
                if (u.id !== editingUser.id && u.correo !== targetEmail) return u;
                const newRol = editForm.rol === 'residente' ? 'user' : (editForm.rol || 'user');
                return {
                    ...u,
                    id: assignedUid || u.id,
                    ...editForm,
                    rol: newRol,
                    nombreUsuario: editForm.usuario,
                    email: targetEmail,
                    correo: targetEmail,
                    esNoAutenticado: false, // Ahora ya está autenticado
                    customFields: customFieldsObj,
                    casaInfo: u.casaInfo ? {
                        ...u.casaInfo,
                        nombre_residente: editForm.nombre,
                        email: targetEmail,
                        customFields: customFieldsObj
                    } : undefined,
                    casasAsociadas: u.casasAsociadas ? u.casasAsociadas.map(c => ({
                        ...c,
                        nombre_residente: editForm.nombre,
                        email: targetEmail,
                        customFields: customFieldsObj
                    })) : [],
                    nuevaContrasena: '',
                    confirmContrasena: ''
                };
            }));

            // Mostrar modal de éxito antes de cerrar
            setConfirmModal({
                isOpen: true,
                title: 'Operación exitosa',
                message: 'Usuario actualizado correctamente.',
                type: 'success',
                confirmText: 'Entendido',
                showCancel: false,
                onConfirm: () => {
                    setConfirmModal(prev => ({ ...prev, isOpen: false }));
                    forceCloseEditModal();
                }
            });
        } catch (error) {
            console.error('Error actualizando usuario', error);
            setSaving(false);
        }
    };

    const handleSendReset = async (usuario) => {
        const correo = usuario.correo || usuario.email;
        if (!correo) {
            setResetFeedback({
                email: 'Correo no disponible',
                error: true,
                message: 'El usuario no tiene un correo válido en su perfil.',
            });
            return;
        }

        try {
            setSendingReset(usuario.id);
            console.log('[GestionarUsuarios] Solicitando restablecimiento vía publicRequestPasswordReset para:', correo);
            
            // Usamos la función pública que ya confirmamos que funciona (evita problemas de CORS/IAM en adminSendPasswordReset)
            const publicRequestPasswordReset = httpsCallable(functions, 'publicRequestPasswordReset');
            const result = await publicRequestPasswordReset({ emailOrPhone: correo });

            if (result.data && result.data.success) {
                setResetFeedback({
                    email: correo,
                    error: false,
                    message: 'Enviamos el enlace de restablecimiento a:',
                });
            } else {
                throw new Error(result.data?.message || 'Error en el servidor');
            }
        } catch (error) {
            console.error('[GestionarUsuarios] No se pudo enviar el correo de restablecimiento:', error);
            setResetFeedback({
                email: correo,
                error: true,
                message: 'No se pudo enviar el correo vía SendGrid. ' + (error.message || ''),
            });
        } finally {
            setSendingReset('');
        }
    };

    const handleToggleSuspend = async (usuario) => {
        try {
            // Asegurar que el usuario esté autenticado antes de proceder
            if (!auth.currentUser) {
                throw new Error('No hay una sesión activa de administrador.');
            }

            // Forzar actualización del token para asegurar que el backend reciba las credenciales frescas
            const token = await auth.currentUser.getIdToken(true);

            const toggle = !!usuario.suspendido ? false : true;
            const data = { uid: usuario.id, suspend: toggle };

            console.log(`[GestionarUsuariosAutenticados] Intentando suspensión para UID: ${usuario.id}, Suspend: ${toggle}`);

            try {
                const suspendUser = httpsCallable(functions, 'suspendUser');
                const res = await suspendUser(data);

                if (res.data && res.data.success === false) {
                    throw new Error(res.data.message || 'Error en el servidor.');
                }
            } catch (callableErr) {
                console.warn('Fallo callable suspendUser, intentando fallback HTTP...', callableErr);

                const response = await fetch(SUSPEND_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(data),
                });

                const result = await response.json();
                if (!response.ok || !result?.success) {
                    throw new Error(result?.message || 'Error en el servidor (Fallback HTTP).');
                }
                console.log('Suspensión completada vía Fallback HTTP');
            }

            setUsuariosFracc((prev) => prev.map((u) => (u.id === usuario.id ? { ...u, suspendido: toggle } : u)));

            // Mostrar modal de éxito
            setConfirmModal({
                isOpen: true,
                title: 'Operación exitosa',
                message: `Usuario ${toggle ? 'suspendido' : 'habilitado'} correctamente.`,
                type: 'success',
                showCancel: false,
                confirmText: 'Entendido',
                onConfirm: () => setConfirmModal({ ...confirmModal, isOpen: false }),
            });
        } catch (err) {
            console.error('Error definitivo en suspensión:', err);
            const detailedMsg = err.message || 'No se pudo actualizar la suspensión. Intenta nuevamente.';

            setConfirmModal({
                isOpen: true,
                title: 'Error de suspensión',
                message: detailedMsg,
                type: 'warning',
                showCancel: false,
                confirmText: 'Cerrar',
                onConfirm: () => setConfirmModal({ ...confirmModal, isOpen: false }),
            });
        }
    };

    const handleEliminarCasasYUsuarios = async () => {
        if (!selectedFraccUsuarios) return;

        setEliminandoCasas(true);
        try {
            const eliminarCasasYUsuariosEnCascada = httpsCallable(functions, 'eliminarCasasYUsuariosEnCascada');
            const result = await eliminarCasasYUsuariosEnCascada({ fraccionamientoId: selectedFraccUsuarios });

            if (result.data.success) {
                setConfirmModal({
                    isOpen: true,
                    title: '✅ Eliminación completada',
                    message: result.data.message || 'Las casas y usuarios han sido eliminados exitosamente.',
                    type: 'success',
                    showCancel: false,
                    confirmText: 'Entendido',
                    onConfirm: () => {
                        setConfirmModal({ ...confirmModal, isOpen: false });
                        // Recargar usuarios (ahora debería estar vacío)
                        setSelectedFraccUsuarios('');
                        setUsuariosFracc([]);
                    },
                });
            } else {
                throw new Error(result.data.message || 'Error desconocido');
            }
        } catch (error) {
            console.error('Error eliminando casas y usuarios:', error);
            setConfirmModal({
                isOpen: true,
                title: '❌ Error al eliminar',
                message: error.message || 'No se pudieron eliminar las casas y usuarios. Intenta nuevamente.',
                type: 'warning',
                showCancel: false,
                confirmText: 'Cerrar',
                onConfirm: () => setConfirmModal({ ...confirmModal, isOpen: false }),
            });
        } finally {
            setEliminandoCasas(false);
        }
    };

    const handleDetachFromFracc = async () => {
        if (!editingUser) return;

        setConfirmModal({
            isOpen: true,
            title: '¿Quitar del fraccionamiento?',
            message: 'El usuario será desvinculado del fraccionamiento y enviado a Control de Sesiones. Esta acción no se puede deshacer.',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, quitar',
            onConfirm: async () => {
                setConfirmModal({ ...confirmModal, isOpen: false });
                try {
                    const ref = doc(db, 'usuarios', editingUser.id);
                    await updateDoc(ref, {
                        fraccionamientoId: null,
                        fraccionamientoTd: null,
                        fraccionamientosAsignados: [],
                    });
                    setUsuariosFracc((prev) => prev.filter((u) => u.id !== editingUser.id));

                    setConfirmModal({
                        isOpen: true,
                        title: 'Usuario desvinculado',
                        message: 'El usuario fue enviado a Control de Sesiones exitosamente.',
                        type: 'success',
                        showCancel: false,
                        confirmText: 'Ir a Control de Sesiones',
                        onConfirm: () => {
                            setConfirmModal({ ...confirmModal, isOpen: false });
                            forceCloseEditModal();
                            navigate('/configuracion/sesiones');
                        },
                    });
                } catch (err) {
                    console.error('No se pudo desvincular', err);
                    setConfirmModal({
                        isOpen: true,
                        title: 'Error',
                        message: 'No se pudo desvincular del fraccionamiento. Intenta nuevamente.',
                        type: 'warning',
                        showCancel: false,
                        confirmText: 'Cerrar',
                        onConfirm: () => setConfirmModal({ ...confirmModal, isOpen: false }),
                    });
                }
            },
            onCancel: () => setConfirmModal({ ...confirmModal, isOpen: false }),
        });
    };

    const openRegModal = async (usuario, specificCasaId = null) => {
        if (esCasaCaseta(usuario) || esCasaCaseta(usuario.casaInfo)) {
            alert('Esta vivienda/usuario corresponde a Caseta/Seguridad y está blindada contra regularizaciones financieras.');
            return;
        }

        const casaId = specificCasaId || usuario.casaInfo?.id || (usuario.casasAsociadas && usuario.casasAsociadas[0]?.id);
        if (!casaId || !selectedFraccUsuarios) {
            alert('Este usuario no tiene una casa vinculada para regularizar.');
            return;
        }

        setRegUser(usuario);
        setShowRegModal(true);
        setRegActiveTab('datos');
        setRegLoading(true);

        try {
            const casaRef = doc(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', casaId);
            const casaSnap = await getDoc(casaRef);
            
            let casaData = {};
            if (casaSnap.exists()) {
                casaData = casaSnap.data();
            }

            if (esCasaCaseta(casaData)) {
                alert('Esta vivienda/usuario corresponde a Caseta/Seguridad y está blindada contra regularizaciones financieras.');
                setShowRegModal(false);
                setRegLoading(false);
                return;
            }

            // Cargar configuración de fraccionamiento para cuota vigente
            const fraccRef = doc(db, 'fraccionamientos', selectedFraccUsuarios);
            const fraccSnap = await getDoc(fraccRef);
            if (fraccSnap.exists()) {
                setRegSubdivisionConfig(fraccSnap.data().configuracionFinanciera || {});
            }

            // Cargar histórico de cuotas del fraccionamiento
            const histRef = collection(db, 'fraccionamientos', selectedFraccUsuarios, 'historicoCuotas');
            const histSnap = await getDocs(histRef);
            const histList = histSnap.docs.map(d => ({ id: d.id, ...d.data() }))
                .sort((a, b) => {
                    const scoreA = (b.anioInicio || b.añoInicio || 0) * 12 + (b.mesInicio || 1);
                    const scoreB = (a.anioInicio || a.añoInicio || 0) * 12 + (a.mesInicio || 1);
                    return scoreA - scoreB;
                });
            setRegHistoricoList(histList);

            // Cargar meses pendientes (Tab 3)
            const mesesRef = collection(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', casaId, 'mesesPendientes');
            const mesesSnap = await getDocs(mesesRef);
            const mesesList = mesesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
                .sort((a, b) => b.id.localeCompare(a.id)); 
            setRegMesesData(mesesList);
            setRegCurrentPage(1);

            // Cargar multas administrativas no pagadas del residente
            const multasRef = collection(db, 'fraccionamientos', selectedFraccUsuarios, 'multasAdministrativas');
            const qMultas = query(multasRef, where('casaId', '==', casaId));
            const multasSnap = await getDocs(qMultas);
            const multasEncontradas = multasSnap.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(m => !m.pagada);
            setRegMultasList(multasEncontradas);

            // Calcular meses de mantenimiento pendientes de forma exacta (año actual e históricos "his-")
            const mesesMantenimientoPendientes = mesesList.filter(m => 
                (/^\d{4}-\d{2}$/.test(m.id) || m.id.startsWith('his-')) && 
                (m.estado === 'pendiente' || m.estado === 'moroso' || m.estado === 'adeudo' || m.estado === 'pagado_parcial' || m.estado === 'pagado_parcialmente')
            ).length;

            // Calcular en tiempo real el desglose de deudas para inicializar correctamente
            const totalAgua = mesesList
                .filter(m => (m.tipo === 'adeudo_agua' || m.id?.startsWith('AGUA-')) && ['pendiente', 'moroso', 'adeudo', 'pagado_parcial', 'pagado_parcialmente', 'PND', 'pnd'].includes(m.estado))
                .reduce((sum, m) => sum + Number(m.montoPendiente ?? m.monto ?? 0), 0);

            const totalExtras = mesesList
                .filter(m => (m.id?.startsWith('EXT-') || m.tipo === 'cuota_extraordinaria') && m.estado !== 'pagado_completo' && m.estado !== 'pagado_totalmente')
                .reduce((sum, m) => sum + Number(m.montoPendiente ?? m.monto ?? 0), 0);

            const totalMultas = multasEncontradas.reduce((sum, m) => sum + Number(m.monto || 0), 0) +
                mesesList
                    .filter(m => m.id?.startsWith('ADM-') && ['pendiente', 'moroso', 'adeudo', 'pagado_parcial', 'pagado_parcialmente', 'PND', 'pnd'].includes(m.estado))
                    .reduce((sum, m) => sum + Number(m.montoPendiente ?? m.monto ?? 0), 0);

            const nuevoAdeudoCapital = Number(casaData.adeudoCapital || 0);
            const nuevoAdeudoIntereses = Number(casaData.adeudoIntereses || 0);
            const saldoFavor = Number(casaData.saldoFavor || 0);

            const nuevoAdeudoTotal = Math.max(0, nuevoAdeudoCapital + nuevoAdeudoIntereses + totalAgua + totalExtras + totalMultas - saldoFavor);

            // Inicializar el estado de la casa con los valores exactos calculados dinámicamente desde Firestore
            setRegCasaData({
                id: casaId,
                ...casaData,
                adeudo: nuevoAdeudoTotal,
                adeudoCapital: nuevoAdeudoCapital,
                adeudoIntereses: nuevoAdeudoIntereses,
                adeudoAgua: totalAgua,
                cuotasExtras: totalExtras,
                adeudoMultas: totalMultas,
                sancionesAdmin: totalMultas,
                saldoFavor: saldoFavor,
                mesesAdeudo: mesesMantenimientoPendientes
            });

        } catch (error) {
            console.error("Error cargando datos de regularización:", error);
        } finally {
            setRegLoading(false);
        }
    };




    const handleDeleteHistorico = async (id) => {
        try {
            const docRef = doc(db, 'fraccionamientos', selectedFraccUsuarios, 'historicoCuotas', id);
            await deleteDoc(docRef);
            setRegHistoricoList(prev => prev.filter(item => item.id !== id));
        } catch (error) {
            console.error("Error al eliminar cuota histórica:", error);
        }
    };

    const handleRecalcularAdeudo = () => {
        if (!regCasaData || !regSubdivisionConfig || esCasaCaseta(regCasaData)) return;
        
        // Filtrar los meses de mantenimiento ordinario (ID formato AAAA-MM o prefijo his-)
        const mesesMantenimiento = regMesesData.filter(m => /^\d{4}-\d{2}$/.test(m.id) || m.id.startsWith('his-'));

        let totalCalculado = 0;
        let numMeses = 0;

        if (mesesMantenimiento.length > 0) {
            // Caso A: Si existen meses de mantenimiento en el historial, sumamos sus saldos pendientes reales
            totalCalculado = mesesMantenimiento.reduce((sum, m) => {
                const pendiente = m.montoPendiente !== undefined 
                    ? Number(m.montoPendiente) 
                    : (Number(m.monto || m.cuotaMensual || 0) - Number(m.montoPagado || 0));
                return sum + Math.max(0, pendiente);
            }, 0);
            
            // Los meses de adeudo serán la cantidad de meses con saldo pendiente > 0
            numMeses = mesesMantenimiento.filter(m => {
                const pendiente = m.montoPendiente !== undefined 
                    ? Number(m.montoPendiente) 
                    : (Number(m.monto || m.cuotaMensual || 0) - Number(m.montoPagado || 0));
                return Math.max(0, pendiente) > 0;
            }).length;
        } else {
            // Caso B (Fallback): Si no hay historial, usamos la estimación teórica histórica
            numMeses = regCasaData.mesesAdeudo || 0;
            if (numMeses <= 0) {
                alert("Ingresa el número de meses de adeudo primero.");
                return;
            }

            const now = new Date();
            const anioActual = now.getFullYear();
            const mesActual = now.getMonth() + 1;
            
            let tempRetroDate = new Date(anioActual, mesActual - 1, 1);
            const cuotaVigente = parseFloat(regSubdivisionConfig.montoMensual || 0);

            for (let i = 0; i < numMeses; i++) {
                const anio = tempRetroDate.getFullYear();
                const mes = tempRetroDate.getMonth() + 1;
                let cuotaMes = cuotaVigente;

                if (anio <= anioActual) {
                    const scoreMes = anio * 12 + mes;
                    const hist = regHistoricoList.find(h => {
                        const scoreIni = (h.anioInicio || h.añoInicio || 0) * 12 + (h.mesInicio || 1);
                        const scoreFin = (h.anioFin || h.añoFin || 0) * 12 + (h.mesFin || 12);
                        return scoreMes >= scoreIni && scoreMes <= scoreFin;
                    });
                    if (hist && hist.cuota > 0) {
                        cuotaMes = hist.cuota;
                    }
                }
                
                totalCalculado += cuotaMes;
                tempRetroDate.setMonth(tempRetroDate.getMonth() - 1);
            }
        }

        const totalMantenimientoCapital = totalCalculado;
        const totalMantenimientoIntereses = Number(regCasaData.adeudoIntereses ?? regCasaData.adeudoInteres ?? 0);
        // Adeudo Mantenimiento Capital (solo capital histórico calculado)
        const nuevoAdeudoCapital = totalMantenimientoCapital;

        const totalAgua = regMesesData
            .filter(m => m.tipo === 'adeudo_agua' && (m.estado === 'pendiente' || m.estado === 'moroso'))
            .reduce((sum, m) => sum + Number(m.montoPendiente ?? m.monto ?? 0), 0);
        const totalExtras = regMesesData
            .filter(m => (m.id?.startsWith('EXT-') || m.tipo === 'cuota_extraordinaria') && m.estado !== 'pagado_completo' && m.estado !== 'pagado_totalmente')
            .reduce((sum, m) => sum + Number(m.montoPendiente ?? m.monto ?? 0), 0);
        const totalMultas = regMultasList.reduce((sum, m) => sum + Number(m.monto || 0), 0);
        const saldoFavor = Number(regCasaData.saldoFavor || 0);

        // Adeudo Total (adeudo) = Capital + Intereses + Agua + Extras + Multas - SaldoFavor
        const nuevoAdeudoTotal = Math.max(0, nuevoAdeudoCapital + totalMantenimientoIntereses + totalAgua + totalExtras + totalMultas - saldoFavor);

        setRegCasaData(prev => ({
            ...prev,
            adeudo: nuevoAdeudoTotal,
            adeudoCapital: nuevoAdeudoCapital,
            adeudoIntereses: totalMantenimientoIntereses,
            adeudoInteres: totalMantenimientoIntereses,
            mesesAdeudo: numMeses
        }));
    };

    const handleSaveRegFields = async () => {
        if (!regCasaData || !selectedFraccUsuarios) return;
        setRegSaving(true);
        try {
            const casaRef = doc(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', regCasaData.id);
            const { id, ...updateData } = regCasaData;
            await updateDoc(casaRef, updateData);
            
            setConfirmModal({
                isOpen: true,
                title: '✅ Campos guardados',
                message: 'Los valores financieros se han actualizado. Ahora puedes aplicar la regularización.',
                type: 'success',
                confirmText: 'Aceptar',
                showCancel: false,
                onConfirm: () => setConfirmModal(prev => ({ ...prev, isOpen: false }))
            });
        } catch (error) {
            console.error("Error guardando campos financieros:", error);
            alert("No se pudieron guardar los cambios.");
        } finally {
            setRegSaving(false);
        }
    };

    const handleExecuteReg = async () => {
        if (!regCasaData || !selectedFraccUsuarios || esCasaCaseta(regCasaData)) return;
        
        setConfirmModal({
            isOpen: true,
            title: 'Confirmar Regularización',
            message: `¿Estás seguro de regularizar la casa ${regCasaData.numero}? Se recalculan adeudos históricos y se generan meses de 2026.`,
            type: 'info',
            confirmText: 'Sí, regularizar ahora',
            showCancel: true,
            onConfirm: async () => {
                setConfirmModal(prev => ({ ...prev, isOpen: false }));
                setRegExecuting(true);
                try {
                    // Auto-guardar primero cualquier cambio realizado en los campos del modal (incluyendo Mantenimiento Capital)
                    const casaRefSave = doc(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', regCasaData.id);
                    const { id, ...updateData } = regCasaData;
                    await updateDoc(casaRefSave, updateData);

                    const migrarCasa = httpsCallable(functions, 'migrarCasaAMesesPendientes');
                    const result = await migrarCasa({ fraccionamientoId: selectedFraccUsuarios, casaId: regCasaData.id });
                    
                    if (result.data?.success) {
                        // Refrescar status de meses (Tab 3)
                        const mesesRef = collection(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', regCasaData.id, 'mesesPendientes');
                        const mesesSnap = await getDocs(mesesRef);
                        const mesesList = mesesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
                            .sort((a, b) => b.id.localeCompare(a.id));
                        setRegMesesData(mesesList);

                        // Refrescar casa (Tab 2 e inputs)
                        const casaRef = doc(db, 'fraccionamientos', selectedFraccUsuarios, 'casas', regCasaData.id);
                        const casaSnap = await getDoc(casaRef);
                        if (casaSnap.exists()) setRegCasaData({ id: casaSnap.id, ...casaSnap.data() });

                        setConfirmModal({
                            isOpen: true,
                            title: '✅ Regularización Exitosa',
                            message: 'La casa ha sido regularizada dinámicamente según los adeudos registrados.',
                            type: 'success',
                            confirmText: 'Genial',
                            showCancel: false,
                            onConfirm: () => setConfirmModal(prev => ({ ...prev, isOpen: false }))
                        });
                    } else {
                        alert("Hubo un problema: " + (result.data?.reason || 'Error desconocido'));
                    }
                } catch (error) {
                    console.error("Error ejecutando regularización:", error);
                    alert("Error al ejecutar: " + error.message);
                } finally {
                    setRegExecuting(false);
                }
            }
        });
    };


    return (
        <div className="gestion-usuarios-container">
            {resetFeedback && (
                <div className="reset-modal-backdrop">
                    <div className={`reset-modal ${resetFeedback.error ? 'error' : 'success'}`}>
                        <div className="reset-modal-header">
                            {resetFeedback.error ? (
                                <FiAlertTriangle className="reset-modal-icon error" />
                            ) : (
                                <FiCheckCircle className="reset-modal-icon success" />
                            )}
                            <div>
                                <p className="reset-modal-title">{resetFeedback.error ? 'No se pudo enviar' : 'Correo de restablecimiento enviado'}</p>
                                <p className="reset-modal-subtitle">{resetFeedback.message}</p>
                            </div>
                        </div>
                        <div className="reset-modal-body">
                            <div className="reset-modal-email">{resetFeedback.email || 'Correo no disponible'}</div>
                            {resetFeedback.error ? (
                                <p className="reset-modal-hint">Confirma que el usuario existe en Auth y que el correo sea correcto.</p>
                            ) : (
                                <p className="reset-modal-hint">Pide al usuario revisar bandeja de entrada o spam.</p>
                            )}
                        </div>
                        <div className="reset-modal-footer">
                            <button className="reset-modal-btn" onClick={() => setResetFeedback(null)}>Aceptar</button>
                        </div>
                    </div>
                </div>
            )}
            <div className="gestion-usuarios-header">
                <PlatformBackButton />
                <div className="gestion-usuarios-title">
                    <FaUsers className="gestion-usuarios-icon" />
                    <div>
                        <h1>Editar Perfil - Usuarios Autenticados</h1>
                        <p>Consulta y gestiona usuarios por fraccionamiento (correo, nombre y contraseña almacenada).</p>
                    </div>
                </div>
            </div>

            <div className="gestion-usuarios-card">
                <div className="toolbar-section v2-layout">
                    <div className="search-box-v3">
                        <FaSearch className="inner-search-icon" />
                        <input
                            type="text"
                            name="search_users_auth_prevent_autofill"
                            id="search_users_auth_prevent_autofill"
                            placeholder="Buscar por nombre, correo, casa, usuario, rol..."
                            autoComplete="off"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1); // Reset al buscar
                            }}
                        />
                    </div>

                    <div className="fracc-selector-v2">
                        <select
                            id="fraccUsuarios"
                            value={selectedFraccUsuarios}
                            onChange={handleSelectFraccUsuarios}
                            disabled={loadingFraccionamientos}
                        >
                            <option value="">Selecciona fraccionamiento</option>
                            {(searchTerm ? fraccionamientos.filter((f) => {
                                const term = searchTerm.toLowerCase();
                                const nombreFracc = (f.nombre || '').toLowerCase();
                                if (nombreFracc.includes(term)) return true;
                                const usuariosDelFracc = usuariosPorFracc[f.id] || [];
                                return usuariosDelFracc.some((u) => {
                                    const nombreUsuario = (u.nombre || '').toLowerCase();
                                    const correoUsuario = (u.correo || '').toLowerCase();
                                    return nombreUsuario.includes(term) || correoUsuario.includes(term);
                                });
                            }) : fraccionamientos).map((fracc) => (
                                <option key={fracc.id} value={fracc.id}>{fracc.nombre}</option>
                            ))}
                        </select>
                    </div>

                    {selectedFraccUsuarios && (
                        <button
                            type="button"
                            className="delete-pill-btn"
                            onClick={() => {
                                setConfirmModal({
                                    isOpen: true,
                                    title: '⚠️ Eliminar Casas y Usuarios',
                                    message: `¿Estás seguro de que deseas eliminar TODAS las casas del fraccionamiento "${fraccionamientos.find(f => f.id === selectedFraccUsuarios)?.nombre || selectedFraccUsuarios}" y todos los usuarios relacionados?\n\nEsta acción:\n• Eliminará todas las casas del fraccionamiento\n• Eliminará todos los usuarios relacionados (excepto superadmin)\n• Eliminará los usuarios de Firebase Authentication\n• NO se puede deshacer\n\n⚠️ Los usuarios con rol "superadmin" NO serán eliminados.`,
                                    type: 'warning',
                                    showCancel: true,
                                    confirmText: 'Sí, eliminar todo',
                                    onConfirm: async () => {
                                        setConfirmModal({ ...confirmModal, isOpen: false });
                                        await handleEliminarCasasYUsuarios();
                                    },
                                });
                            }}
                            disabled={eliminandoCasas}
                            title="Eliminar casas y usuarios"
                        >
                            {eliminandoCasas ? 'Eliminando...' : 'Eliminar Casas'}
                        </button>
                    )}
                </div>

                <div className="gestion-usuarios-body">
                    {usuariosLoading && <p className="gestion-usuarios-status">Cargando usuarios…</p>}
                    {usuariosError && <p className="gestion-usuarios-error">{usuariosError}</p>}
                    {!usuariosLoading && !usuariosError && selectedFraccUsuarios && usuariosFracc.length === 0 && (
                        <p className="gestion-usuarios-status">No encontramos usuarios para este fraccionamiento.</p>
                    )}

                    {!usuariosLoading && usuariosFracc.length > 0 && (() => {
                        const filteredUsuarios = usuariosFracc.filter((usuario) => {
                            if (!searchTerm) return true;
                            const term = searchTerm.toLowerCase();
                            const nombre = (usuario.nombre || usuario.displayName || usuario.nombreUsuario || '').toLowerCase();
                            const correo = (usuario.correo || usuario.email || '').toLowerCase();
                            const usuarioLogin = (usuario.nombreUsuario || usuario.email || '').toLowerCase();
                            const rol = (usuario.rol || '').toLowerCase();
                            const casaNumero = usuario.casasAsociadas && usuario.casasAsociadas.length > 0
                                ? usuario.casasAsociadas.map(c => c.numero || '').join(' ').toLowerCase()
                                : (usuario.casaInfo?.numero || '').toString().toLowerCase();
                            return nombre.includes(term) || correo.includes(term) || usuarioLogin.includes(term) || rol.includes(term) || casaNumero.includes(term);
                        }).sort(compararUsuariosPorCasa);

                        if (filteredUsuarios.length === 0) {
                            return <p className="gestion-usuarios-status">No se encontraron resultados para "{searchTerm}"</p>;
                        }

                        const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
                        const paginatedUsuarios = filteredUsuarios.slice(startIndex, startIndex + ITEMS_PER_PAGE);
                        const totalPages = Math.ceil(filteredUsuarios.length / ITEMS_PER_PAGE);

                        return (
                            <div className="gestion-usuarios-table-wrapper">
                                <table className="gestion-usuarios-table">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Correo</th>
                                            <th>Casa</th>
                                            <th>Usuario</th>
                                            <th>Rol</th>
                                            <th>Fecha autenticación</th>
                                            <th className="th-actions">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedUsuarios.map((usuario) => {
                                            const nombre = usuario.nombre || usuario.displayName || usuario.nombreUsuario || '—';
                                            const correo = usuario.correo || usuario.email || '—';
                                            // PRIORIDAD: nombre_residente de la casa > nombreUsuario > usuario > email
                                            const usuarioLogin = usuario.casaInfo?.nombre_residente || usuario.nombreUsuario || usuario.usuario || usuario.email || '—';
                                            const rol = usuario.rol || '—';
                                            const authDate = formatDateTime(resolveAuthDate(usuario));
                                            return (
                                                <tr key={usuario.id}>
                                                    <td data-label="Nom">
                                                        <div className="user-cell-name">{nombre}</div>
                                                    </td>
                                                    <td data-label="Email">{correo}</td>
                                                    <td data-label="Casa">
                                                        {usuario.casasAsociadas && usuario.casasAsociadas.length > 0 
                                                            ? usuario.casasAsociadas.map(c => c.numero || c.id).join(', ') 
                                                            : (usuario.casaInfo?.numero || '—')}
                                                    </td>
                                                    <td data-label="Usr">{usuarioLogin}</td>
                                                    <td data-label="Rol">
                                                        <span className={`badge-role role-${rol}`}>{rol}</span>
                                                    </td>
                                                    <td data-label="Auth">{authDate}</td>
                                                    <td data-label="Acc">
                                                        <div className="acciones-col">

                                                            {correo && correo !== '—' ? (
                                                                <button
                                                                    type="button"
                                                                    className="icon-action-btn btn-key"
                                                                    onClick={() => handleSendReset(usuario)}
                                                                    disabled={sendingReset === usuario.id}
                                                                    title="Restablecer contraseña"
                                                                >
                                                                    <FaKey />
                                                                </button>
                                                            ) : null}
                                                            <button
                                                                type="button"
                                                                className="icon-action-btn btn-edit"
                                                                onClick={() => openEditModal(usuario)}
                                                                title="Editar usuario"
                                                            >
                                                                    <FaPen />
                                                            </button>
                                                            {(usuario.casaInfo?.id || (usuario.casasAsociadas && usuario.casasAsociadas.length > 0)) && !esCasaCaseta(usuario) && !esCasaCaseta(usuario.casaInfo) && !(usuario.casasAsociadas || []).some(c => esCasaCaseta(c)) && (
                                                                <button
                                                                    type="button"
                                                                    className="icon-action-btn btn-dollar"
                                                                    onClick={() => openRegModal(usuario)}
                                                                    title="Regularizar situación financiera"
                                                                >
                                                                    <FaDollarSign />
                                                                </button>
                                                            )}

                                                            {!String(usuario.id).startsWith('casa_') && (
                                                                <button
                                                                    type="button"
                                                                    className={`icon-action-btn ${usuario.suspendido ? 'unlock' : 'lock'}`}
                                                                    onClick={() => handleToggleSuspend(usuario)}
                                                                    title={usuario.suspendido ? 'Habilitar usuario' : 'Suspender usuario'}
                                                                >
                                                                    {usuario.suspendido ? <FiUnlock /> : <FiLock />}
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>

                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>

                                {/* Controles de Paginación */}
                                {totalPages > 1 && (
                                    <div className="v3-pagination-container">
                                        <div className="pagination-info">
                                            Mostrando <strong>{startIndex + 1}</strong> - <strong>{Math.min(startIndex + ITEMS_PER_PAGE, filteredUsuarios.length)}</strong> de <strong>{filteredUsuarios.length}</strong> usuarios
                                        </div>
                                        <div className="pagination-controls">
                                            <button 
                                                className="pagination-btn arrow" 
                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                            >
                                                <FaChevronLeft />
                                            </button>
                                            
                                            {/* Generar números de página dinámicamente */}
                                            {(() => {
                                                const pages = [];
                                                const maxVisiblePages = 5;
                                                let startPage = Math.max(1, currentPage - 2);
                                                const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                                                
                                                if (endPage - startPage < maxVisiblePages - 1) {
                                                    startPage = Math.max(1, endPage - maxVisiblePages + 1);
                                                }

                                                for (let i = startPage; i <= endPage; i++) {
                                                    pages.push(
                                                        <button 
                                                            key={i} 
                                                            className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
                                                            onClick={() => setCurrentPage(i)}
                                                        >
                                                            {i}
                                                        </button>
                                                    );
                                                }
                                                return pages;
                                            })()}

                                            <button 
                                                className="pagination-btn arrow" 
                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                disabled={currentPage === totalPages}
                                            >
                                                <FaChevronRight />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </div>
            </div>

            {editingUser && (
                <div className="edit-modal-backdrop" role="dialog" aria-modal="true">
                    <div className="edit-modal">
                        <header className="edit-modal-head">
                            <h3>Editar usuario</h3>
                            <button type="button" className="close-btn" onClick={handleCloseEditModal}>×</button>
                        </header>
                        <div className="edit-modal-body">
                            {/* Tabs */}
                            <div className="tab-bar">
                                <button type="button" className={`tab-btn ${activeTab === 'perfil' ? 'active' : ''}`} onClick={() => setActiveTab('perfil')}>Perfil</button>
                                <button type="button" className={`tab-btn ${activeTab === 'campos' ? 'active' : ''}`} onClick={() => setActiveTab('campos')}>Campos personalizados</button>
                            </div>

                            {activeTab === 'perfil' && (
                                <div className="form-grid">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Nombre
                                            <input type="text" name="nombre" value={editForm.nombre} onChange={handleEditChange} placeholder="Ej: Juan Pérez" />
                                        </label>
                                        <span className="form-helper-text">Nombre completo del usuario o residente.</span>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">
                                            Correo
                                            <input type="email" name="correo" value={editForm.correo} onChange={handleEditChange} placeholder="usuario@ejemplo.com" />
                                        </label>
                                        <span className="form-helper-text">Correo electrónico para inicio de sesión y notificaciones.</span>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">
                                            Usuario
                                            <input type="text" name="usuario" value={editForm.usuario} onChange={handleEditChange} placeholder="nombre de usuario" />
                                        </label>
                                        <span className="form-helper-text">Identificador único en el sistema.</span>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">
                                            Rol
                                            <select name="rol" value={editForm.rol} onChange={handleEditChange} className="form-select">
                                                <option value="">Seleccionar rol...</option>
                                                <option value="platformadmin">Platform Admin</option>
                                                <option value="superadmin">Super Admin</option>
                                                <option value="user">User</option>
                                                <option value="caseta">Caseta</option>
                                            </select>
                                        </label>
                                        <span className="form-helper-text">Nivel de permisos del usuario.</span>
                                    </div>

                                    <div className="form-group full-width">
                                        <label className="form-label">
                                            Fecha autenticación
                                            <input type="text" value={formatDateTime(resolveAuthDate(editingUser))} disabled className="form-input-disabled" />
                                        </label>
                                        <span className="form-helper-text">Fecha del último registro o inicio de sesión.</span>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">
                                            Nueva Contraseña
                                            <div className="password-wrapper">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    name="nuevaContrasena"
                                                    value={editForm.nuevaContrasena}
                                                    onChange={handleEditChange}
                                                    autoComplete="new-password"
                                                    placeholder="Dejar vacío para mantener actual"
                                                />
                                                <button
                                                    type="button"
                                                    className="toggle-password"
                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                >
                                                    {showPassword ? <FiEyeOff /> : <FiEye />}
                                                </button>
                                            </div>
                                        </label>
                                        <span className="form-helper-text">Escribe solo si deseas cambiar la contraseña manualmente.</span>
                                        {passwordError && <span className="form-error-text">{passwordError}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">
                                            Confirmar contraseña
                                            <div className="password-wrapper">
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    name="confirmContrasena"
                                                    value={editForm.confirmContrasena}
                                                    onChange={handleEditChange}
                                                    autoComplete="new-password"
                                                    placeholder="Repite la contraseña"
                                                />
                                                <button
                                                    type="button"
                                                    className="toggle-password"
                                                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                                                >
                                                    {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                                                </button>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'campos' && (
                                <div className="custom-fields-container">
                                    <div className="cf-header-row">
                                        <div>Nombre del Campo</div>
                                        <div>Valor / Información</div>
                                        <div />
                                    </div>
                                    <div className="cf-body">
                                        {customFields.length === 0 ? (
                                            <div className="cf-empty-state">
                                                <div className="cf-empty-state-icon"><FaUsers style={{ opacity: 0.2 }} /></div>
                                                <p>No hay campos personalizados adicionales para este usuario.</p>
                                                <p style={{ fontSize: '0.8rem', marginTop: '4px' }}>Haz clic en el botón inferior para agregar uno.</p>
                                            </div>
                                        ) : (
                                            customFields.map((item, idx) => (
                                                <div className="cf-item-row" key={`cf_${idx}`}>
                                                    <input
                                                        className="cf-input-styled"
                                                        type="text"
                                                        value={item.name}
                                                        placeholder="Ej: Teléfono 2"
                                                        onChange={(e) => {
                                                            const v = e.target.value;
                                                            setCustomFields((prev) => prev.map((r, i) => i === idx ? { ...r, name: v } : r));
                                                        }}
                                                    />
                                                    <input
                                                        className="cf-input-styled"
                                                        type="text"
                                                        value={item.value}
                                                        placeholder="Valor o descripción"
                                                        onChange={(e) => {
                                                            const v = e.target.value;
                                                            setCustomFields((prev) => prev.map((r, i) => i === idx ? { ...r, value: v } : r));
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="cf-delete-btn"
                                                        onClick={() => setCustomFields((prev) => prev.filter((_, i) => i !== idx))}
                                                        title="Eliminar campo"
                                                    >
                                                        <FaTimes />
                                                    </button>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    <div className="cf-add-footer">
                                        <button
                                            type="button"
                                            className="cf-add-pill-btn"
                                            onClick={() => setCustomFields([...customFields, { name: '', value: '' }])}
                                        >
                                            <FaPlus /> Agregar nuevo campo personalizado
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <footer className="edit-modal-footer">
                            <button
                                type="button"
                                className={`modal-action-btn ${editingUser.suspendido ? 'unlock' : 'lock'}`}
                                title={editingUser.suspendido ? 'Habilitar usuario' : 'Suspender usuario'}
                                onClick={() => handleToggleSuspend(editingUser)}
                            >
                                {editingUser.suspendido ? <FiUnlock /> : <FiLock />}
                                <span>{editingUser.suspendido ? 'Habilitar' : 'Suspender'}</span>
                            </button>
                            <div className="footer-right">
                                <button type="button" className="ghost-btn" onClick={handleCloseEditModal} disabled={saving}>Cancelar</button>
                                <button type="button" className="detach-btn" onClick={handleDetachFromFracc} disabled={saving}>
                                    Quitar del fraccionamiento
                                </button>
                                <button type="button" className="primary-btn" onClick={handleSave} disabled={saving}>
                                    {saving ? 'Guardando…' : 'Guardar cambios'}
                                </button>
                            </div>
                        </footer>
                    </div>
                </div>
            )}

            {/* Modal de Regularización Financiera */}
            {showRegModal && (
                <div className="edit-modal-backdrop" role="dialog" aria-modal="true">
                    <div className={`edit-modal ${isHistoricDebt ? 'status-accumulation' : ''}`} style={{ maxWidth: '60rem' }}>
                        <header className="edit-modal-head">
                            <h3>Regularización: {regUser?.nombre} - Casa {regCasaData?.numero}</h3>
                            <button type="button" className="close-btn" onClick={() => setShowRegModal(false)}>×</button>
                        </header>
                        <div className="edit-modal-body">
                            {regUser?.casasAsociadas && regUser.casasAsociadas.length > 1 && (
                                <div className="reg-casa-selector" style={{ margin: '0 0 20px 0', padding: '12px 16px', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                    <label htmlFor="regCasaSelect" style={{ fontWeight: '700', color: '#1e293b', fontSize: '0.95rem' }}>Seleccionar Casa a Regularizar:</label>
                                    <select 
                                        id="regCasaSelect"
                                        value={regCasaData?.id || ''}
                                        onChange={(e) => openRegModal(regUser, e.target.value)}
                                        style={{ padding: '8px 16px', borderRadius: '8px', border: '1.5px solid #cbd5e1', backgroundColor: '#ffffff', color: '#0f172a', cursor: 'pointer', fontSize: '0.95rem', fontWeight: '600', outline: 'none' }}
                                    >
                                        {regUser.casasAsociadas.map((casa) => (
                                            <option key={casa.id} value={casa.id}>
                                                {casa.numero} {casa.nombre_residente ? `(${casa.nombre_residente})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="tab-bar">
                                <button type="button" className={`tab-btn ${regActiveTab === 'datos' ? 'active' : ''}`} onClick={() => setRegActiveTab('datos')}>1. Editar Datos</button>
                                <button type="button" className={`tab-btn ${regActiveTab === 'info' ? 'active' : ''}`} onClick={() => setRegActiveTab('info')}>2. Información de Vista</button>
                                <button type="button" className={`tab-btn ${regActiveTab === 'estatus' ? 'active' : ''}`} onClick={() => setRegActiveTab('estatus')}>3. Estatus Meses</button>
                            </div>

                            {regLoading ? (
                                <p style={{ textAlign: 'center', padding: '40px' }}>Cargando información financiera...</p>
                            ) : (
                                <>
                                    {regActiveTab === 'datos' && regCasaData && (
                                        <div className="reg-form-container">
                                            <div className="reg-grid-3col">
                                                <div className="reg-field-group">
                                                    <label className="form-label" style={{ display: 'flex', alignItems: 'center' }}>
                                                        Adeudo Total
                                                        <span title="Total del estado de cuenta actual (Mantenimiento + Consumos/Agua + Extras + Multas - Saldo Favor)" style={{ marginLeft: '6px', color: '#94a3b8', cursor: 'help', fontSize: '0.85rem' }}>ℹ️</span>
                                                    </label>
                                                    <div className="input-with-action">
                                                        <input 
                                                            type="number" 
                                                            value={regCasaData.adeudo || 0} 
                                                            onChange={(e) => setRegCasaData({...regCasaData, adeudo: parseFloat(e.target.value) || 0})}
                                                        />
                                                        <button 
                                                            type="button" 
                                                            className="calc-btn-mini"
                                                            onClick={handleRecalcularAdeudo}
                                                            title="Calcular basado en meses y cuotas históricas"
                                                        >
                                                            <FaChevronDown style={{ transform: 'rotate(180deg)' }} /> 🧮
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="reg-field-group">
                                                    <label className="form-label" style={{ display: 'flex', alignItems: 'center' }}>
                                                        Mantenimiento
                                                        <span title="Deuda de mantenimiento ordinario acumulada con intereses" style={{ marginLeft: '6px', color: '#94a3b8', cursor: 'help', fontSize: '0.85rem' }}>ℹ️</span>
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        value={regCasaData.adeudoCapital || 0} 
                                                        onChange={(e) => setRegCasaData({...regCasaData, adeudoCapital: parseFloat(e.target.value) || 0})}
                                                    />
                                                </div>
                                                <div className="reg-field-group">
                                                    <label className="form-label" style={{ display: 'flex', alignItems: 'center' }}>
                                                        Adeudo Intereses
                                                        <span title="Desglose de intereses moratorios incluidos en el mantenimiento" style={{ marginLeft: '6px', color: '#94a3b8', cursor: 'help', fontSize: '0.85rem' }}>ℹ️</span>
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        value={regCasaData.adeudoIntereses || 0} 
                                                        onChange={(e) => setRegCasaData({...regCasaData, adeudoIntereses: parseFloat(e.target.value) || 0})}
                                                    />
                                                </div>
                                                <div className="reg-field-group">
                                                    <label className="form-label" style={{ display: 'flex', alignItems: 'center' }}>
                                                        Meses Adeudo
                                                        <span title="Cantidad total de meses que se deben" style={{ marginLeft: '6px', color: '#94a3b8', cursor: 'help', fontSize: '0.85rem' }}>ℹ️</span>
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        value={regCasaData.mesesAdeudo || 0} 
                                                        onChange={(e) => setRegCasaData({...regCasaData, mesesAdeudo: parseInt(e.target.value) || 0})}
                                                    />
                                                </div>
                                                <div className="reg-field-group">
                                                    <label className="form-label" style={{ display: 'flex', alignItems: 'center' }}>
                                                        Intereses Aplicados
                                                        <span title="Meses sobre los cuales se ha cobrado interés" style={{ marginLeft: '6px', color: '#94a3b8', cursor: 'help', fontSize: '0.85rem' }}>ℹ️</span>
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        value={regCasaData.mesesInteresAplicados || 0} 
                                                        onChange={(e) => setRegCasaData({...regCasaData, mesesInteresAplicados: parseInt(e.target.value) || 0})}
                                                    />
                                                </div>
                                                <div className="reg-field-group">
                                                    <label className="form-label" style={{ display: 'flex', alignItems: 'center' }}>
                                                        Saldo a Favor
                                                        <span title="Crédito disponible para futuros pagos" style={{ marginLeft: '6px', color: '#94a3b8', cursor: 'help', fontSize: '0.85rem' }}>ℹ️</span>
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        value={regCasaData.saldoFavor || 0} 
                                                        onChange={(e) => setRegCasaData({...regCasaData, saldoFavor: parseFloat(e.target.value) || 0})}
                                                    />
                                                </div>
                                            </div>

                                            {/* Sección Informativa de Desglose de Adeudos */}
                                            <div className="reg-historic-section" style={{ marginTop: '20px', padding: '16px', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                                <h4 style={{ margin: '0 0 12px 0', color: '#1e293b', fontWeight: '700' }}>📊 Desglose del Adeudo Total</h4>
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                                                    <div style={{ padding: '10px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#64748b', display: 'block', fontWeight: '600' }}>Mantenimiento Capital</span>
                                                        <strong style={{ fontSize: '1.1rem', color: '#0f172a' }}>${(regCasaData.adeudoCapital || 0).toFixed(2)}</strong>
                                                    </div>
                                                    <div style={{ padding: '10px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#64748b', display: 'block', fontWeight: '600' }}>Mantenimiento Intereses</span>
                                                        <strong style={{ fontSize: '1.1rem', color: '#0f172a' }}>${(regCasaData.adeudoIntereses || 0).toFixed(2)}</strong>
                                                    </div>
                                                    <div style={{ padding: '10px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#0284c7', display: 'block', fontWeight: '600' }}>Agua Potable</span>
                                                        <strong style={{ fontSize: '1.1rem', color: '#0284c7' }}>
                                                            ${(regCasaData.adeudoAgua || 0).toFixed(2)}
                                                        </strong>
                                                    </div>
                                                    <div style={{ padding: '10px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#f59e0b', display: 'block', fontWeight: '600' }}>Cuotas Extraordinarias</span>
                                                        <strong style={{ fontSize: '1.1rem', color: '#f59e0b' }}>
                                                            ${(regCasaData.cuotasExtras || 0).toFixed(2)}
                                                        </strong>
                                                    </div>
                                                    <div style={{ padding: '10px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#ec4899', display: 'block', fontWeight: '600' }}>Sanciones Administrativas</span>
                                                        <strong style={{ fontSize: '1.1rem', color: '#ec4899' }}>
                                                            ${(regCasaData.adeudoMultas || regCasaData.sancionesAdmin || 0).toFixed(2)}
                                                        </strong>
                                                    </div>
                                                    <div style={{ padding: '10px', backgroundColor: '#f1f5f9', borderRadius: '8px', border: '1.5px solid #b91c1c', gridColumn: '1 / -1' }}>
                                                        <span style={{ fontSize: '0.85rem', color: '#b91c1c', display: 'block', fontWeight: '700' }}>Total Sumado Calculado (Debe coincidir con Adeudo Total)</span>
                                                        <strong style={{ fontSize: '1.3rem', color: '#b91c1c' }}>
                                                            ${(
                                                                (regCasaData.adeudoCapital || 0) + 
                                                                (regCasaData.adeudoIntereses || 0) + 
                                                                (regCasaData.adeudoAgua || 0) + 
                                                                (regCasaData.cuotasExtras || 0) + 
                                                                (regCasaData.adeudoMultas || regCasaData.sancionesAdmin || 0)
                                                            ).toFixed(2)}
                                                        </strong>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="reg-footer-actions">
                                                <button 
                                                    className="btn-reg-execute" 
                                                    onClick={handleExecuteReg} 
                                                    disabled={regExecuting || regSaving}
                                                >
                                                    {regExecuting ? '⚙️ Procesando...' : '🔍 Regularizar Individual'}
                                                </button>
                                                <button className="primary-btn" onClick={handleSaveRegFields} disabled={regSaving}>
                                                    {regSaving ? 'Guardando...' : '💾 Guardar Campos'}
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {regActiveTab === 'info' && regCasaData && (
                                        <div className="reg-info-list">
                                            <div className="info-item">
                                                <span className="info-label">Convenio Activo</span>
                                                <span className="info-value">{regCasaData.convenioActivo ? 'SÍ' : 'NO'}</span>
                                            </div>
                                            <div className="info-item">
                                                <span className="info-label">Fecha Última Regularización</span>
                                                <span className="info-value">
                                                    {regCasaData.fechaRegularizacion 
                                                        ? (regCasaData.fechaRegularizacion.toDate 
                                                            ? formatDateTime(regCasaData.fechaRegularizacion.toDate()) 
                                                            : (regCasaData.fechaRegularizacion.seconds 
                                                                ? formatDateTime(new Date(regCasaData.fechaRegularizacion.seconds * 1000)) 
                                                                : String(regCasaData.fechaRegularizacion)))
                                                        : 'Nunca'}
                                                </span>
                                            </div>

                                            <div className="info-item">
                                                <span className="info-label">Meses Gracia</span>
                                                <span className="info-value">{regCasaData.mesesPermitidosGracia || 0}</span>
                                            </div>
                                            <div className="info-item">
                                                <span className="info-label">Moroso</span>
                                                <span className="info-value" style={{ color: regCasaData.moroso ? '#ef4444' : '#10b981' }}>
                                                    {regCasaData.moroso ? 'SÍ' : 'NO'}
                                                </span>
                                            </div>
                                            <div className="info-item" style={{ gridColumn: '1 / -1' }}>
                                                <span className="info-label">Status Regularización (Field)</span>
                                                <span className="info-value">{regCasaData.regularizadoAMesesPendientes ? 'COMPLETADO' : 'PENDIENTE'}</span>
                                            </div>
                                        </div>
                                    )}

                                    {regActiveTab === 'estatus' && (
                                        <div className="reg-status-wrapper">
                                            <table className="reg-status-table">
                                                <thead>
                                                    <tr>
                                                        <th>Estado</th>
                                                        <th>Mes Histórico (ID)</th>
                                                        <th>Cuota Mensual</th>
                                                        <th>Pagado</th>
                                                        <th>Pendiente</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginatedRegMeses.length === 0 ? (
                                                        <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No hay registros disponibles.</td></tr>
                                                    ) : (
                                                        paginatedRegMeses.map(mes => (
                                                            <React.Fragment key={mes.id}>
                                                                <tr className={`${mes.isGroup ? 'reg-row-group' : ''} ${expandedRegYears.includes(mes.id) ? 'expanded' : ''}`}>
                                                                    <td data-label="Edo">
                                                                        <span className={`reg-status-badge status-${mes.estado?.split('_')[0]}`}>
                                                                            {mes.estado === 'pendiente' ? 'Pnd' : 
                                                                             mes.estado?.startsWith('pagado') ? 'Pag' : 
                                                                             mes.estado?.startsWith('parcial') ? 'Par' : 
                                                                             (mes.estado || 'N/A').substring(0,3)}
                                                                        </span>
                                                                    </td>
                                                                    <td data-label="Hist">
                                                                        <div className="hist-id-container">
                                                                            <strong>{mes.displayId || mes.id.replace('his-', '')}</strong>
                                                                            {mes.isGroup && (
                                                                                <button 
                                                                                    type="button"
                                                                                    className={`hist-count-badge trigger ${expandedRegYears.includes(mes.id) ? 'active' : ''}`}
                                                                                    onClick={() => toggleRegYear(mes.id)}
                                                                                    title={expandedRegYears.includes(mes.id) ? 'Contraer detalle' : 'Ver detalle por mes'}
                                                                                >
                                                                                    {mes.count}
                                                                                    {expandedRegYears.includes(mes.id) ? <FaChevronDown /> : <FaChevronRight />}
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td data-label="Cuota" className="td-monto-small">
                                                                        ${(mes.cuotaMensual || 0).toFixed(2)}
                                                                        {mes.isGroup && <span className="monto-avg-label">/mes</span>}
                                                                    </td>
                                                                    <td data-label="Pagado" className="td-monto-small">${(mes.montoPagado || 0).toFixed(2)}</td>
                                                                    <td data-label="Pend" className="td-monto-small">${(mes.montoPendiente || 0).toFixed(2)}</td>
                                                                </tr>
                                                                {/* Desglose de meses agrupados */}
                                                                {mes.isGroup && expandedRegYears.includes(mes.id) && (
                                                                    mes.meses.sort((a,b) => b.mes - a.mes).map(child => (
                                                                        <tr key={child.id} className="reg-row-child">
                                                                            <td data-label="Edo">
                                                                                <span className={`reg-status-badge status-${child.estado?.split('_')[0]}`}>
                                                                                    {child.estado === 'pendiente' ? 'Pnd' : 
                                                                                     child.estado?.startsWith('pagado') ? 'Pag' : 
                                                                                     child.estado?.startsWith('parcial') ? 'Par' : 
                                                                                     (child.estado || 'N/A').substring(0,3)}
                                                                                </span>
                                                                            </td>
                                                                            <td data-label="Hist" style={{ paddingLeft: '2.5rem' }}>
                                                                                <span className="hist-child-id">{child.mesNombre || child.id.replace('his-', '')}</span>
                                                                            </td>
                                                                            <td data-label="Cuota" className="td-monto-small">${(child.cuotaMensual || 0).toFixed(2)}</td>
                                                                            <td data-label="Pagado" className="td-monto-small">${(child.montoPagado || 0).toFixed(2)}</td>
                                                                            <td data-label="Pend" className="td-monto-small">${(child.montoPendiente || 0).toFixed(2)}</td>
                                                                        </tr>
                                                                    ))
                                                                )}
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>

                                            {totalRegPages > 1 && (
                                                <div className="reg-pagination">
                                                    <button 
                                                        type="button" 
                                                        className="reg-page-btn" 
                                                        onClick={() => setRegCurrentPage(prev => Math.max(prev - 1, 1))}
                                                        disabled={regCurrentPage === 1}
                                                    >
                                                        <FaChevronLeft /> Anterior
                                                    </button>
                                                    <span className="reg-page-info">
                                                        Página {regCurrentPage} de {totalRegPages}
                                                    </span>
                                                    <button 
                                                        type="button" 
                                                        className="reg-page-btn" 
                                                        onClick={() => setRegCurrentPage(prev => Math.min(prev + 1, totalRegPages))}
                                                        disabled={regCurrentPage === totalRegPages}
                                                    >
                                                        Siguiente <FaChevronRight />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}


                                </>
                            )}
                        </div>
                        <footer className="edit-modal-footer">
                            <button type="button" className="ghost-btn" onClick={() => setShowRegModal(false)}>Cerrar</button>
                        </footer>
                    </div>
                </div>
            )}

            {/* Modal de confirmación para Platform Admin */}
            {showPlatformAdminConfirm && (
                <div className="edit-modal-backdrop" role="dialog" aria-modal="true">
                    <div className="edit-modal confirm-modal" style={{ maxWidth: '480px' }}>
                        <header className="edit-modal-head">
                            <h3>⚠️ Confirmación - Rol de Platform Admin</h3>
                            <button type="button" className="close-btn" onClick={handleCancelPlatformAdmin}>×</button>
                        </header>
                        <div className="edit-modal-body" style={{ padding: '2rem' }}>
                            <p style={{ margin: '0 0 1rem 0', fontSize: '1rem', color: '#374151' }}>
                                Estás asignando el rol <strong>Platform Admin</strong> a <strong>{editingUser?.nombre || editingUser?.correo}</strong>.
                            </p>
                            <p style={{ margin: '0 0 1rem 0', fontSize: '1rem', color: '#374151' }}>
                                Este es el rol de <strong>Gerente de Plataforma</strong> con máximos permisos. ¿Estás seguro?
                            </p>
                            <div style={{ backgroundColor: '#FEF3C7', border: '1px solid #FCD34D', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem' }}>
                                <p style={{ margin: '0', fontSize: '0.9rem', color: '#92400E' }}>
                                    El usuario podrá gestionar todos los fraccionamientos y usuarios de la plataforma.
                                </p>
                            </div>
                        </div>
                        <footer className="edit-modal-footer">
                            <button type="button" className="ghost-btn" onClick={handleCancelPlatformAdmin}>Cancelar</button>
                            <button type="button" className="primary-btn" onClick={handleConfirmPlatformAdmin} style={{ backgroundColor: '#d97706' }}>
                                Confirmar - Asignar Platform Admin
                            </button>
                        </footer>
                    </div>
                </div>
            )}

            {/* Modal de confirmación estilizado */}
            <ConfirmModal
                isOpen={confirmModal.isOpen}
                title={confirmModal.title}
                message={confirmModal.message}
                type={confirmModal.type}
                confirmText={confirmModal.confirmText}
                cancelText={confirmModal.cancelText}
                showCancel={confirmModal.showCancel}
                confirmColor={confirmModal.confirmColor}
                cancelColor={confirmModal.cancelColor}
                onConfirm={confirmModal.onConfirm}
                onCancel={confirmModal.onCancel || (() => setConfirmModal({ ...confirmModal, isOpen: false }))}
            />
        </div>
    );
};

export default GestionarUsuariosAutenticados;
